var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "lg": "3",
      "md": "2",
      "sm": "0"
    }
  }), _c('b-col', {
    attrs: {
      "lg": "6",
      "md": "8",
      "sm": "12"
    }
  }, [_c('b-card', [_c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("accountDetails.changePassword")) + " ")])]), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("oldPassword")))]), _c('v-text-field', {
    attrs: {
      "id": "password",
      "placeholder": _vm.$t('enterOldPassword'),
      "type": "text",
      "required": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.oldPassword,
      callback: function ($$v) {
        _vm.oldPassword = $$v;
      },
      expression: "oldPassword"
    }
  }), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("newPassword")))]), _c('v-text-field', {
    attrs: {
      "id": "password",
      "placeholder": _vm.$t('newPassword'),
      "type": _vm.showPassword1 ? 'password' : 'text',
      "append-icon": _vm.showPassword1 ? 'mdi-eye-off' : 'mdi-eye',
      "required": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "click:append": _vm.togglePasswordVisibility1
    },
    model: {
      value: _vm.newPassword,
      callback: function ($$v) {
        _vm.newPassword = $$v;
      },
      expression: "newPassword"
    }
  }), _vm.newPassword && _vm.passwordValidationMessage ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" " + _vm._s(_vm.passwordValidationMessage) + " ")]) : _vm._e(), _c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("confirmNewPassword")))]), _c('v-text-field', {
    staticClass: "password-field",
    attrs: {
      "id": "password1",
      "placeholder": _vm.$t('confirmNewPassword'),
      "type": _vm.showPassword2 ? 'password' : 'text',
      "append-icon": _vm.showPassword2 ? 'mdi-eye-off' : 'mdi-eye',
      "required": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "click:append": _vm.togglePasswordVisibility2
    },
    model: {
      value: _vm.confirmPassword,
      callback: function ($$v) {
        _vm.confirmPassword = $$v;
      },
      expression: "confirmPassword"
    }
  }), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary mr-3 pr-3 pl-3",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/profile');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.cancel")) + " ")]), _c('button', {
    staticClass: "btn btn-primary editSaveBtn ml-3 pr-4 pl-4",
    on: {
      "click": _vm.updateProfile
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.save")) + " ")])])], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "3",
      "md": "2",
      "sm": "0"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }